import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton/LinkAsButton';
import { Helmet } from 'react-helmet-async';
import plannerStyles from './index.scss';
import styles from './HowItWorks.scss';
import { getURLParamValue } from '../../../redux/modules/recipes/utils/get-url-param-value';

export const HowItWorks = () => {
  const builder = getURLParamValue('builder');
  const nextUrl = builder ? `../serves?builder=${builder}` : '../serves';

  return (
    <>
      <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
      <div className={classnames(styles.content, plannerStyles.content)}>
        <Typography component="h1" styleAs="screenHeadingSmall">
          How it works?
        </Typography>

        <dl className={styles.columns}>
          <div className={styles['col-1']}>
            <Typography component="dt" styleAs="paragraphHeading">
              1. Based on your tastes
            </Typography>
            <Typography component="dd" styleAs="paragraph">
              Your dinner meal plan is based on your chosen preferences
            </Typography>
          </div>

          <div className={styles['col-2']}>
            <Typography component="dt" styleAs="paragraphHeading">
              2. Flexible
            </Typography>
            <Typography component="dd" styleAs="paragraph">
              Remove or swap any recipe from your meal plan
            </Typography>
          </div>

          <div className={styles['col-3']}>
            <Typography component="dt" styleAs="paragraphHeading">
              3. Fast
            </Typography>
            <Typography component="dd" styleAs="paragraph">
              Add all your meal plan ingredients to your trolley in one click
            </Typography>
          </div>
        </dl>

        <LinkAsButton
          component={Link}
          to={nextUrl}
          /* @ts-expect-error finalising prop */
          theme="finalising"
          className={plannerStyles.nextButton}
        >
          Continue
        </LinkAsButton>
      </div>
    </>
  );
};

export default HowItWorks;
